import { preference } from "./_duck"

export const PREFERENCE_GET_REQUEST: string = preference.defineType("PREFERENCE_GET_REQUEST")
export const PREFERENCE_GET_SUCCESS: string = preference.defineType("PREFERENCE_GET_SUCCESS")
export const PREFERENCE_GET_FAILURE: string = preference.defineType("PREFERENCE_GET_FAILURE")

export const PREFERENCE_PUT_REQUEST: string = preference.defineType("PREFERENCE_PUT_REQUEST")
export const PREFERENCE_PUT_SUCCESS: string = preference.defineType("PREFERENCE_PUT_SUCCESS")
export const PREFERENCE_PUT_FAILURE: string = preference.defineType("PREFERENCE_PUT_FAILURE")
